import React, { useState, useRef, useEffect } from "react";
import { SearchInput } from "./search-input";
import {
  Button,
  Form,
  InputGroup,
  Overlay,
  Popover,
} from "react-bootstrap";
import { Search, Sliders2Vertical, X } from "react-bootstrap-icons";
import { useFilterStore } from "../../model";

interface HeaderChatProps {
  handleSearch: (query: string) => void;
  isCollapsed: boolean;
  onFilterChange?: (filters: {
    read: string;
    registration: string;
  }) => void;
}

export const HeaderChat = ({ handleSearch, isCollapsed, onFilterChange }: HeaderChatProps) => {
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [showFilters, setShowFilters] = useState(false);

  const containerRef = useRef<HTMLDivElement | null>(null);
  const filterButtonRef = useRef<HTMLButtonElement | null>(null);

  const state = useFilterStore(state => state);
  // const { read, registration, setRead, setRegistration } = useFilterStore();

  const filteredHandler = (title: string, value: string) => {
    if (title === "read") {
      useFilterStore.setState({ read: value as "read" | "all" | "unread" });
    } else if (title === "registration") {
      useFilterStore.setState({ registration: value as "all" | "registered" | "unregistered" });
    }
    
    onFilterChange?.({ read: state.read, registration: state.registration });
  };

  useEffect(() => {
    const updateWidth = () => {
      setContainerWidth(containerRef.current?.clientWidth || 0);
    };
    updateWidth();
    const observer = new ResizeObserver(updateWidth);
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => observer.disconnect();
  }, [isCollapsed]);

  const isFiltered = state.registration !== "all" || state.read !== "all";

  return (
    <div ref={containerRef}>
      <div
        className={`d-flex align-items-center 
          ${containerWidth < 201 ? "justify-content-between" : ""} 
        gap-2 flex-nowrap`}
      >
        {containerWidth > 160 && <SearchInput onSearch={handleSearch} />}

        {containerWidth < 161 && containerWidth > 88 && (
          <Button
            variant="outline-secondary"
            className="mb-2 rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
            style={{ width: 38, height: 38, padding: 0 }}
            onClick={() => setShowSearchInput((prev) => !prev)}
          >
            <Search />
          </Button>
        )}

        {containerWidth > 128 && (
          <Button
            ref={filterButtonRef}
            variant={isFiltered ? "secondary" : "outline-secondary"}
            className="mb-2 rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
            style={{ width: 38, height: 38, padding: 0 }}
            onClick={() => setShowFilters((prev) => !prev)} 
          >
            <Sliders2Vertical />
          </Button>
        )}

        <Button
          variant="outline-secondary"
          className="mb-2 d-none d-lg-block rounded-circle d-flex align-items-center justify-content-center"
          style={{ opacity: 0, width: 38, height: 38, flexShrink: 0 }}
          aria-hidden="true"
        />
      </div>

      <Overlay
        show={showFilters}
        target={filterButtonRef.current}
        placement="bottom"
        containerPadding={10}
        rootClose
        onHide={() => setShowFilters(false)}
      >
        <Popover id="filters-popover">
          <Popover.Header as="h3">Фильтры</Popover.Header>
          <Popover.Body>
            <Form>
              <Form.Check
                type="radio"
                name="read-status"
                id="read-all"
                label="Все"
                checked={state.read === "all"}
                onChange={() => filteredHandler("read", "all")}
              />
              <Form.Check
                type="radio"
                name="read-status"
                id="read-read"
                label="Прочитанные"
                checked={state.read === "read"}
                onChange={() => filteredHandler("read", "read")}
              />
              <Form.Check
                type="radio"
                name="read-status"
                id="read-unread"
                label="Непрочитанные"
                checked={state.read === "unread"}
                onChange={() => filteredHandler("read", "unread")}
              />

              <hr style={{ margin: "0.5rem 0", borderColor: "#3336384c" }} />

              <Form.Check
                type="radio"
                name="registration-status"
                id="reg-all"
                label="Все"
                checked={state.registration === "all"}
                onChange={() => filteredHandler("registration", "all")}
              />
              <Form.Check
                type="radio"
                name="registration-status"
                id="reg-unregistered"
                label="Приглашенны"
                checked={state.registration === "unregistered"}
                onChange={() => filteredHandler("registration", "unregistered")}
              />
              <Form.Check
                type="radio"
                name="registration-status"
                id="reg-registered"
                label="Зарегистрированные"
                checked={state.registration === "registered"}
                onChange={() => filteredHandler("registration", "registered")}
              />
            </Form>
          </Popover.Body>
        </Popover>
      </Overlay>

      {showSearchInput && containerWidth < 161 && containerWidth > 88 && (
        <SearchInput onSearch={handleSearch} />
      )}
      {containerWidth > 88 && (
        <InputGroup>
          {folderName && (
            <InputGroup.Text
              onClick={() => {
                setFolderName("");
                setError(null);
              }}
              style={{ cursor: "pointer" }}
              className="rounded-end-pill"
            >
              <X />
            </InputGroup.Text>
          )}
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        </InputGroup>
      )}
    </div>
  );
};